import { PublicClientApplication } from "@azure/msal-browser";

// Redirect nur zur Basis-URL, MSAL wird Redirect nicht automatisch steuern
const redirectUri = window.location.origin;

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: redirectUri,
    navigateToLoginRequestUrl: false 
  },
  cache: {
    // Do not persist tokens in browser storage.
    cacheLocation: "memoryStorage",
    // Required for redirect flow with in-memory cache; stores only transient auth state.
    storeAuthStateInCookie: true
  },
  // system: {
  //   loggerOptions: {
  //     loggerCallback: (level: any, message: any) => {
  //       if (level === LogLevel.Error) {
  //           console.error(`[MSAL] ${message}`);
  //       } else if (level === LogLevel.Info) {
  //           console.info(`[MSAL] ${message}`);
  //       } else if (level === LogLevel.Verbose) {
  //           console.debug(`[MSAL] ${message}`);
  //       } else if (level === LogLevel.Warning) {
  //           console.warn(`[MSAL] ${message}`);
  //       }
  //     },
  //     piiLoggingEnabled: true,
  //     logLevel: LogLevel.Verbose
  //   }
  // }
};

export const msalInstance = new PublicClientApplication(msalConfig);
